import React from 'react';
import Header from './Header';
import Footer from './Footer';
import PromoBanner from '../common/PromoBanner';
import './Layout.css';

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <PromoBanner />
      <Header />
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
